import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderDetails', {
  modify: 'Modificar',
  details: 'Detalle'
});
